import { useEffect, useMemo, useState } from 'react'
import { parseAsInteger, parseAsString, useQueryState } from 'nuqs'
import { SCENARIOS_PER_PAGE } from 'routes/constants'
import { useScenarioTemplates } from 'routes/Scenarios/context/ScenariosContext'
import { getFilteredScenarios } from 'routes/Scenarios/helpers'
import { ScenarioTemplateCompact } from 'routes/Scenarios/helpers/types'

export function useScenarios() {
  const scenarios = useScenarioTemplates()

  const [filteredScenarios, setFilteredScenarios] = useState<
    ScenarioTemplateCompact[]
  >([])
  const [loading, setLoading] = useState<boolean>(true)

  const [search] = useQueryState('search', parseAsString.withDefault(''))
  const [tag] = useQueryState('tag', parseAsString.withDefault(''))
  const [page] = useQueryState('page', parseAsInteger.withDefault(1))

  useEffect(() => {
    setLoading(true)

    const timer = setTimeout(() => {
      const data = getFilteredScenarios(search, tag, scenarios)
      setFilteredScenarios(data)
      setLoading(false)
    }, 500)

    return () => clearTimeout(timer)
  }, [search, tag])

  const visibleScenarios = useMemo(() => {
    const firstPageIndex = (page - 1) * SCENARIOS_PER_PAGE
    const lastPageIndex = firstPageIndex + SCENARIOS_PER_PAGE

    return filteredScenarios.slice(firstPageIndex, lastPageIndex)
  }, [filteredScenarios, page])

  return {
    filteredScenarios,
    visibleScenarios,
    loading,
  }
}
